<template>
  <div class="whs-order-room" v-if="room">
    <div class="whs-order-hotel">
      <div class="whs-order-room-hotel-thumb-wrap">
        <img v-if="hotel.info.thumbnail" :src="hotel.info.thumbnail"
          class="whs-order-room-hotel-thumb" :alt="hotel.info.name" />
      </div>
      <div class="whs-order-hotel-title">
        <div class="whs-breadcrumbs">{{ hotel.info.country }} / {{ hotel.info.city
        }}</div>
        <div class="whs-order-hotel-name">
          {{ hotel.info.name }}
          <div v-if="hotel.info.star_rating" class="whs-list-stars">
            <div v-for="star in (parseInt(hotel.info.star_rating / 10, 10))"
              :key="star" class="whs-list-star whs-icon"></div>
          </div>
        </div>
        <div class="whs-order-hotel-address">{{ hotel.info.clean_address }}</div>

        <div class="whs-order-hotel-kind">{{ hotel.info.kind }}</div>
      </div>
      <div class="whs-order-checkinout">
        <div class="whs-order-checkinout-item">
          <div class="whs-small">Заезд c {{ hotel.info.check_in_time.slice(0, 5)
          }}
          </div>
          <div class="whs-order-checkinout-item-value">{{
            dateToLocaleString(checkinDate) }}</div>
        </div>
        <div class="whs-order-checkinout-item">
          <div class="whs-small">Выезд до {{ hotel.info.check_out_time.slice(0, 5)
          }}</div>
          <div class="whs-order-checkinout-item-value">{{
            dateToLocaleString(checkoutDate) }}</div>
        </div>
      </div>
    </div>
    <div class="whs-order-room-content">
      <div class="whs-order-room-thumb-wrap">
        <img v-if="room.info.thumbnail_tmpl"
          :src="room.info.thumbnail_tmpl.replace('{size}', 'x220')"
          class="whs-order-room-thumb" :alt="room.info.name" />
      </div>
      <div class="whs-order-room-head">
        <div class="whs-order-room-name">{{ room.info.name }}</div>
        <!-- <div class="whs-order-room-subtitle">{{ room.info.name_struct.bedding_type }}</div> -->
        <div class="whs-list__meal whs-icon-left"
          :class="{ 'has-meal': room.meal !== 'nomeal' }">{{
            toLocaleMeal(room.meal)
          }}</div>
      </div>
      <div class="whs-order-room-price-container">
        <div class="whs-order-room-price">
          <div class="whs-list__price">{{ toLocalePrice(calcPrice(room)) }}</div>
          <div class="whs-small">{{ nightsAdults }}</div>
          <div v-if="room.payment_options.payment_types[0].tax_data"
            class="whs-small"
            :class="{ 'has-tax': $parent.$parent.hasTax(room.payment_options.payment_types[0].tax_data) }">
            {{
              $parent.$parent.validateTax(room.payment_options.payment_types[0].tax_data)
            }}</div>
        </div>
        <a class="whs-button-main whs-feedback-link"
          @click="() => scrollTo('feedback-form')">Забронировать</a>
      </div>
    </div>
    <div class="whs-order-hotel-policy" v-html="hotel.info.policy_description">
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { calcPrice, scrollTo } from '@/api';

export default {
  name: 'FeedbackRoom',
  props: {
    room: Object
  },
  computed: {
    ...mapState('hero', [
      'nightsAdults',
      'currencyText',
      'direction',
      'checkinDate',
      'checkoutDate',
      'price'
    ]),
    ...mapState('hotel', ['hotel']),
    ...mapGetters('hero', ['checkin', 'checkout', 'toLocalePrice'])
  },
  methods: {
    dateToLocaleString(date) {
      const month = [
        'янв',
        'фев',
        'мар',
        'апр',
        'мая',
        'июня',
        'июля',
        'авг',
        'сен',
        'окт',
        'нояб',
        'дек'
      ];
      const day = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'];
      return `${day[date.getDay()]}, ${date.getDate()} ${month[date.getMonth()]
        }`;
    },
    toLocaleMeal(meal) {
      const i18n = {
        nomeal: 'Питание не включено',
        breakfast: 'Завтрак включен',
        'breakfast-buffet': 'Завтрак - Шведский стол',
        'continental-breakfast': 'Континентальный завтрак'
      };
      return i18n[meal] ? i18n[meal] : `Питание: ${meal}`;
    },
    calcPrice,
    scrollTo,
    // toLocalePrice(price) {
    //   return `${Math.ceil(this.price(price)).toLocaleString('ru-Ru')} ${
    //     this.currencyText
    //   }`;
    // }
  }
};
</script>

<style scoped>
.whs-breadcrumbs {
  font-size: 13px;
  opacity: 0.7;
}

.whs-order-room {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  flex: 3 3 800px;
}

.whs-order-hotel,
.whs-order-room-content {
  display: flex;
  flex-wrap: wrap;
}

.whs-order-room-hotel-thumb-wrap {
  max-height: 145px;
  flex: 1 0 200px;
  border-bottom: 1px solid var(--color-alt-5);
}

.whs-order-room-hotel-thumb {
  max-width: 100%;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.whs-order-hotel-title {
  padding: 8px 18px;
  flex: 2 0 400px;
  border-bottom: 1px solid var(--color-alt-5);
  border-right: 1px solid var(--color-alt-5);
}

.whs-order-room-thumb-wrap {
  flex: 1 0 200px;
  background-color: var(--color-bg-dark);
}

.whs-order-room-thumb {
  max-width: 100%;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.whs-order-room-head {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 2 0 400px;
  padding: 8px 18px;
  border-bottom: 1px solid var(--color-alt-5);
}

.whs-feedback-link {
  width: unset;
  flex: 0;
  margin-left: 1rem;
  display: none;
}

@media(max-width: 575px) {
  .whs-feedback-link {
    display: flex;
  }
}

.whs-order-room-price-container {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px solid var(--color-alt-5);
  flex: 1 0 200px;
  padding: 8px 18px;
}

.whs-order-room-price {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.whs-order-room-name {
  font-size: 24px;
}

/* .whs-order-room-subtitle {
} */
.whs-order-checkinout {
  display: flex;
  flex-wrap: wrap;
  flex: 1 0 200px;
  align-self: stretch;
}

.whs-order-checkinout-item {
  display: flex;
  flex: 1 0 150px;
  flex-direction: column;
  padding: 8px 18px;
  border-bottom: 1px solid var(--color-alt-5);
}

@media (max-width: 575px) {
  .whs-order-hotel-title {
    border-right: none;
  }

  .whs-order-checkinout-item:nth-child(1) {
    border-right: 1px solid var(--color-alt-5);
  }
}

.whs-order-checkinout-item-value {
  padding: 4px 0;
  font-weight: 500;
  font-size: 16px;
}

.whs-order-hotel-kind {
  display: inline-flex;
  background-color: var(--color-bg);
  padding: 2px 8px;
  border-radius: 24px;
}

.whs-order-hotel-name {
  font-size: 18px;
  padding: 4px 0;
  font-weight: 500;
}

.whs-order-hotel-address {
  font-size: 12px;
  color: var(--color-main);
  margin-bottom: 8px;
}

.whs-order-hotel-policy {
  padding: 8px 18px;
}

.whs-list__price {
  padding-top: 4px;
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 4px;
}

.whs-list__meal {
  margin-top: 8px;
  padding: 2px 4px;
  background-color: var(--color-bg);
  border-radius: 2px;
  display: inline-flex;
}

.whs-list__meal.has-meal {
  background-color: var(--color-third);
  color: #fff;
}

.whs-list__meal:before {
  content: '\f725';
  margin-right: 8px;
  align-self: center;
  text-align: center;
  color: #fff;
}

.whs-list__meal:not(.has-meal):before {
  color: var(--color-text-5);
  content: '\f2e7';
}

.whs-list-stars {
  display: inline-flex;
}

.whs-list-star:before {
  content: '\f005';
  color: var(--color-third);
  font-size: 8px;
  margin-right: 2px;
}

.has-tax {
  font-weight: 500;
  color: var(--color-second);
}
</style>